module.exports = __webpack_public_path__ + "img/end.beffc185.png";